module.exports = __webpack_public_path__ + "static/media/cac_login_logo.e5642c0e.png";